import { backendURL, postRestURL } from "../utils/constants/constants";

export async function postUserToLogin({ body }) {

    try {
        const response = await fetch(`${backendURL}/influencer/authWithMailAndPass`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        console.log(e);
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function getNeedVerification({ email }) {

    try {
        const response = await fetch(`${postRestURL}/rpc/needverification?user_email=${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}